import { render, staticRenderFns } from "./AskTopicDet.vue?vue&type=template&id=b82dc6ec&scoped=true"
import script from "./AskTopicDet.vue?vue&type=script&lang=js"
export * from "./AskTopicDet.vue?vue&type=script&lang=js"
import style0 from "./AskTopicDet.vue?vue&type=style&index=0&id=b82dc6ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82dc6ec",
  null
  
)

export default component.exports